/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import Logo from '~/components/Logo'
import { Grid, Typography, Container } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import useUserState from '~/features/User/stores/UserState'
import dayjs from 'dayjs'
import { ICoordenation } from '~/features/Dispatch/pages/Summary'
import useStationState from '~/features/Station/stores/StationState'

interface IHeaderSummaryProps {
  readonly headerSummary: (ICoordenation & { readonly name?: string }) | null
  readonly showRegistration?: boolean
}

export default function HeaderSummary({ headerSummary, showRegistration = true }: IHeaderSummaryProps) {
  const { translate } = useLang()
  const { user } = useUserState()
  const { station } = useStationState()
  const generateDocument = new Date()
  return (
    <Container fixed={false}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={3} justifyContent="center" alignContent="center">
          <Grid container xs={12}>
            <Grid item xs={12} maxHeight={'95px'} maxWidth={'95px'}>
              <Logo />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
            <b>
              {((showRegistration === false)
                ? translate('Device Schedule')
                : translate('Schedule'))
              }: {headerSummary?.name ?? ''}
            </b>
          </Typography>

          {(showRegistration !== false && headerSummary?.coordinator?.registration !== "") && (
            <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
              {translate('Registration')}: <b>{headerSummary?.coordinator.registration ?? `* ${translate('Uninformed')} *`}</b>
            </Typography>
          )}
          {showRegistration === false && headerSummary?.dispatch_groups && headerSummary.dispatch_groups.length > 0 && (
            <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
              {translate('Dispatch Group')}: <b>{headerSummary.dispatch_groups.map(group => group.name).join(', ')}</b>
            </Typography>
          )}
        </Grid>
        <Grid item xs={3} textAlign={'right'}>
          <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
            {translate('Station')}: {station().get()?.name}
          </Typography>

          <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
            {translate('Document generated in')}
          </Typography>

          <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
            {dayjs(generateDocument).format('DD/MM/YYYY HH:mm:ss')}
          </Typography>

          <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
            {translate('User')}: {user()?.name?.get()}
          </Typography>

          {user()?.registration?.get() && (
            <Typography variant="caption" sx={{ display: 'block', mt: 0.25, mb: 0.25 }}>
              {translate('Registration')}: {user()?.registration?.get()}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Container>
  )
}
